import { Pipe, PipeTransform } from '@angular/core';
import { FolderShareFragment } from '@app/models';

@Pipe({
  name: 'filterUserSharesPipe',
  standalone: false
})
export class FilterUserSharesPipe implements PipeTransform {
  transform(shares: FolderShareFragment[]): FolderShareFragment[] {
    return shares.filter(share => !share.group && share.user && share.user.id && !share.is_by_link);
  }
}
